import {marketplace as axios} from '../../../axios';

export class Item {
  static async getProductById(id, customerId) {
    try {
      const product = await axios.get(`/products/${id}?output_format=JSON`);
      const formId = product.data.product.id_form_field;
      const related = await this.getAssociatedProductByProduct(
        product.data.product,
        customerId,
      );
      console.log('related2', related);
      if (formId && formId !== -1) {
        const formData = await axios.get(`/forms/${formId}?output_format=JSON`);
        return {
          product: await this.productMapping(product.data.product, customerId),
          form: this.formMapping(formData.data.form),
          relatedProducts: related,
        };
      } else {
        return {
          product: await this.productMapping(product.data.product, customerId),
          form: null,
          relatedProducts: related,
        };
      }
      return false;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async getProductSingle(id, customerId) {
    console.log('id io', id);
    try {
      const product = await axios.get(`/products/${id}?output_format=JSON`);
      console.log('io', product.data.product);
      return await this.productMapping(product.data.product, customerId);
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async getAssociatedProductByProduct(product, customerId) {
    if (product.associations.accessories) {
      return await Promise.all(
        product.associations.accessories.map(async accessory => {
          return await this.getProductSingle(accessory.id, customerId);
        }),
      );
    }
    console.log('ettoo');
    return [];
  }

  static async getQuotes(customerId) {
    try {
      const quotes = await axios.get(
        `/quotes?filter[customer]=${customerId}&output_format=JSON&display=full&sort=[id_DESC]`,
      );
      return this.quoteMapping(quotes.data.quotes, customerId);
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async quoteMapping(quotes, customerId) {
    return await Promise.all(
      quotes.map(async quote => {
        console.log('quote', quote.accept_url);
        const product = await this.getProductSingle(quote.product, customerId);
        if (!product) {
          return;
        }
        return {
          id: quote.id,
          product: product,
          status: quote.status,
          // price: quote.price,
          content: quote.content,
          dateAdd: quote.date_add,
          productCategory: quote.product_category.toLowerCase(),
          price: quote.ht,
          acceptUrl: quote.accept_url,
          cancelUrl: quote.cancel_url,
        };
      }),
    );
  }

  static async getHistory(idCustomer) {
    try {
      const history = await axios.get(
        `/orders?filter[id_customer]=${idCustomer}&display=full&output_format=JSON`,
      );
      const orderStates = await axios.get(
        `/order_states?output_format=JSON&&display=full`,
      );

      const categories = await axios.get(
        `/categories?output_format=JSON&display=full`,
      );

      const stateMap = orderStates.data.order_states.reduce((map, state) => {
        map[state.id] = state.name;
        return map;
      }, {});

      let historyData = [];
      if (history.data.orders) {
        historyData = await Promise.all(
          history.data.orders
            .map(async order => {
              return await this.historyMapping(order, stateMap, categories);
            })
            .reverse(),
        );
      }

      const quoteData = await this.getQuotes(idCustomer);

      return {
        history: historyData,
        quotes: quoteData,
      };
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async getOrderDetailById(id, customerId) {
    try {
      const order = await axios.get(
        `/orders/${id}?output_format=JSON&display=full`,
      );
      if (order.status === 200) {
        const addressId = order.data.orders[0].id_address_delivery;
        const address = await axios.get(
          `/addresses/${addressId}?output_format=JSON&display=full`,
        );
        const product = await this.getProductSingle(
          order.data.orders[0].associations.order_rows[0].product_id,
          customerId,
        );
        return this.orderDetailMapping(
          order.data.orders[0],
          address.data.addresses[0],
          product,
        );
      }
      return false;
    } catch (error) {
      console.log('error', error);
      return false;
    }
  }

  static async historyMapping(order, stateMap, categories) {
    const categoryOrder = categories.data.categories.filter(item => {
      return order.product_type == item.id;
    });

    return {
      id: order.id,
      order: order.reference,
      delivery: stateMap[order.current_state] || order.current_state,
      payment: order.payment,
      productName: order.associations.order_rows[0].product_name,
      productCategory: categoryOrder[0]
        ? categoryOrder[0].link_rewrite
        : 'service',
    };
  }

  static async productMapping(product, customerId) {
    let imageUrl = 'https://placehold.co/245x220?text=OHS';
    if (product.associations.images && product.associations.images.length > 0) {
      const imageId = product.associations.images[0].id;
      imageUrl = `${process.env.REACT_APP_MARKETPLACE_API_BASE_URL}images/products/${product.id}/${imageId}?ws_key=${process.env.REACT_APP_MARKETPLACE_API_KEY}`;
    }

    let categoryLinkRewrite = null;
    if (product.associations.categories.length > 0) {
      const categoryId = product.id_category_default;
      const categoryResponse = await axios.get(
        `/categories/${categoryId}?output_format=JSON`,
      );
      categoryLinkRewrite = categoryResponse.data.category.link_rewrite;
    }
    const fav = await axios.get(
      `/wishlist?&filter[id_customer]=${customerId}&display=full&output_format=JSON`,
    );
    let wishlistId = undefined;
    if (fav.data.wishlists) {
      if (fav.data.wishlists.length > 0) {
        wishlistId = fav.data.wishlists[0].id;
      }
    }

    let favorite = false;
    let wishListIdProduct = undefined;
    if (wishlistId) {
      const wish = await axios.get(
        `/wishlist/${wishlistId}?output_format=JSON&display=full`,
      );
      if (wish.data.wishlists.length > 0) {
        if (wish.data.wishlists[0].associations) {
          if (wish.data.wishlists[0].associations.products) {
            favorite = wish.data.wishlists[0].associations.products.some(
              prod => {
                if (prod.id_product === product.id) {
                  wishListIdProduct = prod.id_wishlist_product;
                  return true;
                }
                return false;
              },
            );
          }
        }
      }
    } else {
      console.log('eles');
      const wishList = await axios.post(
        `/wishlist?output_format=JSON`,
        `<prestashop xmlns:xlink="http://www.w3.org/1999/xlink"> 
                        <wishlist>
                            <id_customer>${customerId}</id_customer>
                            <name>Favoris</name>
                            <token>Favoris-${customerId}</token>
                        </wishlist>
                    </prestashop>`,
      );
      wishlistId = wishList.data.wishlist.id;
      const wish = await axios.get(
        `/wishlist/${wishlistId}?output_format=JSON&display=full`,
      );
      if (wish.data.wishlists.length > 0) {
        if (wish.data.wishlists[0].associations) {
          if (wish.data.wishlists[0].associations.products) {
            favorite = wish.data.wishlists[0].associations.products.some(
              prod => {
                if (prod.id_product === product.id) {
                  wishListIdProduct = prod.id_wishlist_product;
                  return true;
                }
                return false;
              },
            );
          }
        }
      }
    }

    return {
      id: product.id,
      name: product.name,
      description: product.description,
      price: product.price ? product.price : null,
      type: product.type,
      image: imageUrl,
      category: categoryLinkRewrite,
      payment_type: product.payment_type,
      favorite: favorite,
      wishlistId: wishlistId,
      howTo: product.how_to ? product.how_to : '',
      seller: product.seller ?? '',
      shopAddress: product.shop_address ?? '',
      shopTel: product.shop_tel ?? '',
      shopContact: product.shop_contact ?? '',
      wishListIdProduct: wishListIdProduct,
      shopEmail: product.shop_email ?? '',
      cgvlink: product.cgv_link ?? '',
    };
  }

  static formMapping(form) {
    console.log('form', form);
    return {
      id: form.id,
      name: form.name,
      description: form.description,
      fields: form.associations
        ? form.associations.fields
            .map(field => {
              return {
                id: field.id,
                name: field.name,
                order: JSON.parse(field.options).order,
                options: JSON.parse(field.options),
              };
            })
            .sort((a, b) => a.order - b.order)
        : [],
    };
  }

  static orderDetailMapping(order, address, product) {
    return {
      title: order.associations.order_rows[0].product_name,
      pickUpDate: 'Vendredi 24 Mars',
      pickUpHour: '08:00 à 16:00',
      pickUpStreet: address.address1,
      pickUpCountry: address.city,
      deliveryPlaceStreet: address.address1,
      deliveryPlaceCountry: address.city,
      quantity: order.associations.order_rows[0].product_quantity,
      price: order.total_products_wt,
      total: order.total_paid_tax_incl,
      shipping: order.total_shipping_tax_incl,
      customerId: order.id_customer,
      orderId: order.id,
      product: product,
      invoiceUrl: order.invoice_url,
      formValues: order.form_values
    };
  }

  static async searchProductByName(name, customerId, postalCode) {
    try {
      const productsResponse = await axios.get(
        `/products?output_format=JSON&display=full&filter[name]=%[${name}]%&filter[active]=1`,
      );
      if (productsResponse.data.length === 0) {
        return [];
      }

      const products = productsResponse.data.products;
      const filteredProducts = await this.getFilteredProductsByPostalCode(
        products,
        postalCode,
      );
      console.log('productsB', products);
      const mappedProducts = await Promise.all(
        filteredProducts.map(async product => {
          return await this.productMapping(product, customerId);
        }),
      );
      console.log('mappedProducts', mappedProducts);
      return mappedProducts;
    } catch (error) {
      console.log('error', error);
      return [];
    }
  }

  static async getAllProducts() {
    try {
      const response = await axios.get(
        '/products?output_format=JSON&display=full&filter[active]=1',
      );
      return response.data.products;
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  }

  static async filterProducts(
    products,
    category,
    productPublicId,
    productPublicValue,
    productTypeId,
    productTypeValue,
  ) {
    return products.filter(product => {
      if (
        category === undefined &&
        productPublicValue === undefined &&
        productTypeValue === undefined
      ) {
        return false;
      }
      let categoryMatch = category === undefined;
      if (product.associations.categories && !categoryMatch) {
        categoryMatch = product.associations.categories.some(
          cat => cat.id === category,
        );
      }
      let publicMatch = productPublicValue === undefined;
      if (product.associations.product_features && !publicMatch) {
        publicMatch = product.associations.product_features.some(
          feature =>
            feature.id === productPublicId &&
            feature.id_feature_value === productPublicValue,
        );
      }
      let typeMatch = productTypeValue === undefined;
      if (product.associations.product_features && !typeMatch) {
        typeMatch = product.associations.product_features.some(
          feature =>
            feature.id === productTypeId &&
            feature.id_feature_value === productTypeValue,
        );
      }
      return categoryMatch && publicMatch && typeMatch;
    });
  }

  static async getFilteredProductsByPostalCode(products, postalCode) {
    return products.filter(product => {
      if (
        postalCode === undefined ||
        product.zone === undefined ||
        product.zone === '' ||
        product.zone === null
      ) {
        return true;
      }
      const zones = product.zone.split(',');
      return zones.includes(postalCode);
    });
  }

  static async getFilteredProducts(
    category,
    productPublicId,
    productPublicValue,
    productTypeId,
    productTypeValue,
    customerId,
    profil,
  ) {
    const products = await this.getAllProducts();
    const productsFiltered = await this.filterProducts(
      products,
      category,
      productPublicId,
      productPublicValue,
      productTypeId,
      productTypeValue,
    );
    const productsFilteredByPostalCode =
      await this.getFilteredProductsByPostalCode(
        productsFiltered,
        profil.postalCode,
      );
    console.log('productsFiltered', productsFiltered);
    return await Promise.all(
      productsFilteredByPostalCode.map(async product => {
        return await this.productMapping(product, customerId);
      }),
    );
  }

  static async getProductFeatureByName(name) {
    try {
      const response = await axios.get(
        `/product_features?output_format=JSON&display=full&filter[name]=${name}`,
      );
      return response.data.product_features[0];
    } catch (error) {
      console.error('Error fetching product feature:', error);
      return [];
    }
  }

  static async getCategories() {
    try {
      const response = await axios.get(
        '/categories?output_format=JSON&display=full',
      );
      return response.data.categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  }

  static async getFeaturesValues(id) {
    try {
      const response = await axios.get(
        `/product_feature_values?output_format=JSON&display=full&filter[id_feature]=${id}`,
      );
      return response.data.product_feature_values;
    } catch (error) {
      console.error('Error fetching feature values:', error);
      return [];
    }
  }

  static async addToFavorite(productId, wishlistId) {
    try {
      const favoriteData = `
            <prestashop xmlns:xlink="http://www.w3.org/1999/xlink">
                <wishlist_product>
                    <id_wishlist>
                        ${wishlistId}
                    </id_wishlist>
                    <id_product>
                        ${productId}
                    </id_product>
                    <quantity>
                        1
                    </quantity>
                </wishlist_product>
            </prestashop>`;
      return await axios.post(
        `/wishlist_product?output_format=JSON`,
        favoriteData,
      );
    } catch (error) {
      console.error('Error adding to favorite:', error);
      return false;
    }
  }

  static removeFromFavorite(productId, wishlistId) {
    try {
      return axios.delete(`/wishlist_product/${wishlistId}`);
    } catch (error) {
      console.error('Error removing from favorite:', error);
      return false;
    }
  }
}
